export { default } from "./OfferLabel";
